import { NavItemAccessor } from '../types/navItemAccessor'
import { NavItemNavigable } from '../types/navItemNavigable'

export const getRealItems = <T extends NavItemNavigable>(items: T[]) =>
  items.filter((item) => !item.accessor || (item.accessor && !Object.values(NavItemAccessor).includes(item.accessor)))
